/* eslint-disable */
import { IState } from "@/interfaces/IState";
import { ILesson } from "@/interfaces/lesson/ILesson";
import axios from "axios";

export const lesson = {
  state: {
    lessons: [],
    lesson: {},
    currentLesson: null,
    lessonInformation: {},
    gridColumnsLesson: true,
    numberColumnGrid: 3,
    generalAdvance: { progress: 0 },
    querySearch: "",
    filterLessonInformation: {},
  },
  mutations: {
    SET_LESSON(state: IState, payload: ILesson) {
      state.lessons = payload;
    },
    SET_PROGRESS(state: IState, payload: ILesson) {
      state.generalAdvance = payload;
    },
    SET_ONE_LESSON(state: IState, payload: ILesson) {
      state.lesson = payload;
    },
    ADD_LESSON(state: IState, payload: ILesson) {
      state.lessons.push(payload);
    },
    SET_INFORMATION_LESSON(state: IState, payload: ILesson) {
      state.lessonInformation = payload;
    },
    SET_COLUMN_GRID_LESSON(state: IState) {
      state.gridColumnsLesson = !state.gridColumnsLesson;
    },
    SET_SEARCH_QUERY(state: IState, payload: boolean) {
      state.querySearch = payload;
    },
    SET_FILTER_INFORMATION_LESSON(state: IState, payload: ILesson) {
      state.filterLessonInformation = payload;
    },
  },
  actions: {
    // get all Lessons
    actionGetLessons: async function (context: any, payload: any) {
      context.commit('SAVING_LOADING', true);

      const pageNumber =
        typeof payload.pageNumber !== "undefined" ? payload.pageNumber : 0;
      const pageSize =
        typeof payload.pageSize !== "undefined" ? payload.pageSize : 8;
      await axios
        .get(
          // `${axios.defaults.baseURL}lesson/?${context.state.querySearch}&pageNumber=${pageNumber}&pageSize=${pageSize}`
          `${axios.defaults.baseURL}lesson/?&pageNumber=${pageNumber}&pageSize=${pageSize}&sectionId=${payload.sectionId}`
        )
        .then((res: any) => {
          context.commit("SET_LESSON", res.data);
          console.info("Clases", res.data);
          context.commit('SAVING_LOADING', false);
        })
        .catch((error: any) => {
          console.info("Error load lessons", error);
          context.commit('SAVING_LOADING', false);
        });
    },
    actionGetProgress: async function (context: any, payload: any) {
      context.commit('SAVING_LOADING', true);
      await axios
        .get(
          `${axios.defaults.baseURL}lesson/progress?&sectionId=${payload.sectionId}`
        )
        .then((res: any) => {
          context.commit("SET_PROGRESS", res.data);
          console.info("Progreso general", res.data);
          context.commit('SAVING_LOADING', false);
        })
        .catch((error: any) => {
          console.info("Error cargando el progreso general", error);
          context.commit('SAVING_LOADING', false);
        });
    },
    async actionGetLesson(context: any, payload: any) {
      context.commit('SAVING_LOADING', true);
      await axios
        .get(`${axios.defaults.baseURL}lesson/${payload}`)
        .then((res: any) => {
          context.commit("SET_ONE_LESSON", res.data);
          console.log("cargar clase", res.data);
          context.commit('SAVING_LOADING', false);
        })
        .catch((error: any) => {
          console.info("Error al cargar la clase", error);
          context.commit('SAVING_LOADING', false);
        });
    },

    // get information lessons (selects)
    async actionGetInformationLesson(context: any, payload: any) {
      context.commit('SAVING_LOADING', true);
      await axios
        .get(`${axios.defaults.baseURL}information/lesson/${payload}`)
        .then(res => {
          console.info(
            "Obteniendo información de la lección",
            res.data
          );
          context.commit("SET_INFORMATION_LESSON", res.data);
          context.commit('SAVING_LOADING', false);
        })
        .catch(error => {
          console.info(
            "error al obtener información de la lección",
            error
          );
          context.commit('SAVING_LOADING', false);
        });
    },
    // get information lessons for filter (selects)
    async actionGetFilterInformationLesson(context: any, payload: any) {
      context.commit('SAVING_LOADING', true);
      let institutionId  = await payload.institutionId;
      if (!institutionId) {
        institutionId  = await payload.institutionContext.institutionId;
      }

      // console.log(payload);
      await axios.get(`${axios.defaults.baseURL}information/filterLesson/${institutionId}`)
        .then((res: any) => {
          console.info("Filtro de clases", res.data);
          context.commit("SET_FILTER_INFORMATION_LESSON", res.data);
          context.commit('SAVING_LOADING', false);
        })
        .catch((error: any) => {
          console.info("error al obtener Filtro de clases", error);
          context.commit('SAVING_LOADING', false);
        });
    },
    async actionFilterLesson(context: any, payload: any) {
      // console.info("do u call??", payload);
      context.commit('SAVING_LOADING', true);
      await axios
        .get(`${axios.defaults.baseURL}lesson/${payload}`)
        .then((res: any) => {
          context.commit("SET_LESSON", res.data);
          context.commit('SAVING_LOADING', false);
        })
        .catch((error: any) => {
          console.info("Error al filtrar las clases", error);
          context.commit('SAVING_LOADING', false);
        });
    },

    // reset lesson
    setLesson(context: any, payload: ILesson) {
      context.commit("SET_LESSON", payload);
    },

    setOneLesson(context: any, payload: ILesson) {
      context.commit("SET_ONE_LESSON", payload);
    },

    // add new lesson to array
    addNewLesson(context: any, payload: ILesson) {
      context.commit("ADD_LESSON", payload);
    },
    getLesson(context: any, payload: ILesson) {
      context.commit("GET_LESSON", payload);
    },
  },
  getters: {
    getLessons(state: IState) {
      return state.lessons;
    },
    getLesson(state: IState) {
      console.info("obteniendo lesson", state.lesson);
      return state.lesson;
    },
    currentLesson: (state: IState) => state.currentLesson,

    getGridColumnLesson(state: IState) {
      return state.gridColumnsLesson;
    },
    getLessonInformation(state: IState) {
      return state.lessonInformation;
    },
    getLessonFilterInformation(state: IState) {
      return state.filterLessonInformation;
    },

    getNumberColumnGridLesson(state: IState) {
      return state.numberColumnGrid;
    },
    getGeneralAdvance(state: IState) {
      return state.generalAdvance;
    },
  },
};
